import React from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import {
  Tabs, Icon, List, Checkbox, Spin, Drawer, Tooltip,
} from 'antd';

import PageFrame from '../../views/PageFrame';
import HeadlineBreadcrumbList from '../../views/HeadlineBreadcrumbList';
import ContentHeader from '../../views/ContentHeader';
import './query.css';
import DrawerFrame from '../../views/DrawerFrame';
import ObjDialog from './ObjDialog';
import IconPlus from '../../views/IconPlus';
import QueryTab from '../QueryTab';
import ButtonList from '../../views/ButtonList';
import Catapult from './Catapult/CatapultContainer';
import TabTitle from './TabTitle';
import Navigator from './Navigator';

const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    display: flex;
    flex-direction: column;
  }
  
  .ant-drawer-body > section {
    display: flex;
    flex-direction: column;
  }
`;

const StyledSpinner = styled(Spin)`
  text-align: center;
  background: rgba(0,0,0,0.05);
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 30px 50px;
  margin: 20px 0;
`;

const IFrameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  iframe {
    flex-grow: 1
  }
`;

const StyledPageFrame2 = styled.div`
  flex: 1;
  height: 100%;
  overflow-y: auto;
  
  .ant-tabs-bar {
    padding-left: 20px;
    display: flex;
    flex-direction: row-reverse;
    .ant-tabs-extra-content { 
      flex: 1; 
      margin-left: 10px;
      button {
        line-height: 1rem;
        margin-top: 5px;
        text-shadow: none;
        box-shadow: none;
        color: #0279c0;
        border: 0;
        &:hover {
          color: #2394cc;
        }
        &.ant-btn-default {
          color: #d9d9d9;
          &:hover {
            color: #2394cc;
          }
        }
        &.ant-btn-danger {
          color: #d9d9d9;
          &:hover {
            color: #2394cc;
          }
        }
        i {
          font-size: 1.3rem;
        }
      }
    }
    .ant-tabs-tab { 
      padding-left: 40px; 
      line-height: auto;
    }
    .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-nav-container { 
      height: auto; 
    }
`;

const ExtraTabButtons = styled.div`
  white-space: nowrap;
  margin-right: 1rem;
`;

const PlusButton = styled.div`
  width: 30px;
  height: 30px;
  border: 1px solid #DDDDDD;
  border-radius: 7px;
  color: #999999;
  cursor: pointer;
  &:hover {
    background-color: #00C43B;
    color: black;
  }
`;

const Plus = styled.span`
    display: block;
    width: 20px;
    height: 20px;
    font-size: 20px;
    position: relative;
    bottom: 3px;
    left: 7px;
    font-weight: bold;
`;

const CAT_LABEL = 'Load Category';

function catLabel(loading) {
  if (loading) {
    return (
      <span>
        {CAT_LABEL}
        <Icon type="loading" style={({ marginLeft: 10 })} />
      </span>
    );
  }
  return CAT_LABEL;
}

const { TabPane } = Tabs;

const GRID = {
  gutter: 8,
  xs: 1,
  sm: 2,
  md: 3,
  lg: 3,
  xl: 4,
};

export default class QueryView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      dateModalVisible: false,
    };
    this.setDateModalVisible = this.setDateModalVisible.bind(this);
  }

  setDateModalVisible(isVisible) {
    this.setState({
      dateModalVisible: isVisible,
    });
  }

  render() {
    const { mediaId, mediaURL, editVisible, onCloseDrawer, currentMediaItem,
      goHome, queryTabs, addTab, updateQueryName,
      removeQuery, doShowMedia, schema, loadCategories,
      queryTabKey, onQueryTabChange, token,
      loadingCat, onCloseCat, onChooseFilter,
      objDialogTitle, showObjDialog, setShowObjDialog, objDialogValue,
      activateObjDialog,
    } = this.props;
    return (
      <div className="query-page" style={{ display: 'flex', height: '100%', overflowY: 'hidden' }}>
        <Navigator collapsed={false}>
          <Catapult token={token} onChooseFilter={onChooseFilter }/>
        </Navigator>
        <StyledPageFrame2>
          <ContentHeader>
            <HeadlineBreadcrumbList>
              {[
                { onClick: goHome, text: 'Home' },
                'Queries',
              ]}
            </HeadlineBreadcrumbList>
          </ContentHeader>
          <Tabs
            activeKey={queryTabKey}
            onChange={onQueryTabChange}
            type="card"
            tabBarExtraContent={(
              <ExtraTabButtons>
                <Tooltip title="Add tab" placement="top">
                  <PlusButton onClick={addTab}><Plus>+</Plus></PlusButton>
                </Tooltip>
              </ExtraTabButtons>
            )}
          >
            {queryTabs.map(data => (
              <TabPane tab={<TabTitle data={data} deleteTab={removeQuery} />} key={data.key} closable={true}>
                <QueryTab
                  {...data}
                  schema={schema}
                  queryKey={data.key}
                  token={token}
                  activateObjDialog={activateObjDialog}
                  updateQueryName={(name) => updateQueryName(name, data)}
                  loadCategories={loadCategories}
                  showMedia={doShowMedia}
                  removeQuery={removeQuery}
                  setDateModalVisible={this.setDateModalVisible}
                />
              </TabPane>
            ))}
          </Tabs>
        </StyledPageFrame2>
    <ObjDialog
      title={objDialogTitle}
      showDialog={showObjDialog}
      onClose={() => setShowObjDialog(false)}
      value={objDialogValue}
    />
        <StyledDrawer
          title="Media Player"
          placement="right"
          closable
          width={600}
          onClose={onCloseDrawer}
          visible={editVisible}
          currentMediaItem={currentMediaItem}
        >
          <DrawerFrame>
            {mediaId ? '' : <StyledSpinner size="large" />}
            {editVisible && mediaId ? (
              <IFrameWrapper>
                <iframe
                  title="Player"
                  style={{
                    border: 'none',
                    width: '100%',
                    height: '100%',
                    flexGrow: 1,
                  }}
                  src={mediaURL}
                />
              </IFrameWrapper>
            ): ''}
          </DrawerFrame>
        </StyledDrawer>
        <StyledDrawer
          title="Load"
          placement="right"
          closable
          width={400}
          onClose={onCloseCat}
          visible={loadingCat}
        >
          <DrawerFrame>
            <Catapult token={token} onChooseFilter={onChooseFilter }/>
          </DrawerFrame>
        </StyledDrawer>
      </div>
    );
  }
}

